import { proxy } from "valtio";

const state = proxy({
  postalUrl: "https://api.postalpincode.in/pincode",
  isLoading: false,
  successModal: false,
  loginModal: false,
  baseUrl: "http://139.59.37.37:1337/api",
  name: "",
  father_name: "",
  email: "",
  address: "",
  phone: 0,
  pin_code: 0,
  city: "",
  state: "",
  ref_code: "",
  validationErrors: "",
  toastOptions: {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
  },
});

export { state };
